import { tailwindSheet, baseStyles } from '../../_shared/styles.js';

const sheet = new CSSStyleSheet();
sheet.replaceSync(`
    :host {
        display: block;
        min-height: 100vh;
    }
`);

export default [tailwindSheet, baseStyles, sheet];